export default "__VITE_ASSET__CRCqVSkk__"